import {createSinglePathSVG} from './TEMPLATE'

export const MagnifyingGlass2_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M11 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l3.387 3.387a1 1 0 0 1-1.414 1.414l-3.387-3.387A8 8 0 0 1 3 11Z',
})
